import type { Container } from 'pixi.js';

export interface FitResult {
  /** Virtual dims to lay out against — `w * scale === screenW`. */
  w: number;
  h: number;
  scale: number;
}

/**
 * Fit a fixed-size layout onto small viewports (Steam Deck browser ≈
 * 1280x720) by scaling the scene root down. Scale never exceeds 1, so
 * normal desktops render pixel-identically. Callers lay out against the
 * returned virtual w/h instead of app.screen — full-bleed rects at the
 * virtual size still cover the physical screen exactly.
 */
export function fitScene(
  root: Container,
  screenW: number,
  screenH: number,
  minW: number,
  minH: number,
): FitResult {
  const scale = Math.min(1, screenW / minW, screenH / minH);
  root.scale.set(scale);
  return { w: screenW / scale, h: screenH / scale, scale };
}
